import { useState } from "react";

export default function useBszDialogs() {
  /**
   * =========================================================
   * ✅ STATE
   * =========================================================
   */

  // ✅ dialog visibility
  const [isRoomDialogOpen, setIsRoomDialogOpen] = useState(false);

  // ✅ editing context
  const [editingRoom, setEditingRoom] = useState(null);

  /**
   * =========================================================
   * ✅ OPEN HANDLERS
   * =========================================================
   */

  const openCreateRoom = () => {
    setEditingRoom(null);
    setIsRoomDialogOpen(true);
  };

  const openEditRoom = (room) => {
    setEditingRoom(room);
    setIsRoomDialogOpen(true);
  };

  /**
   * =========================================================
   * ✅ CLOSE HANDLERS
   * =========================================================
   */

  const closeRoomDialog = () => {
    setIsRoomDialogOpen(false);
    setEditingRoom(null);
  };

  /**
   * =========================================================
   * ✅ HELPERS (derived state)
   * =========================================================
   */

  const isEditing = !!editingRoom;

  /**
   * =========================================================
   * ✅ EXPORT (stable API)
   * =========================================================
   */

  return {
    // ✅ state
    createRoomOpen: isRoomDialogOpen, // ✅ backward compatible
    editingRoom,
    isEditing,

    // ✅ setters (keep for flexibility)
    setCreateRoomOpen: setIsRoomDialogOpen,
    setEditingRoom,

    // ✅ handlers
    openCreateRoom,
    openEditRoom,
    closeRoomDialog,
  };
}
